var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.s.container},[_c('Icon',{attrs:{"icon":"faq","className":_vm.s.icon}}),_c('div',{class:[_vm.s.text]},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }